import request from '../../utils/request';
import { Search } from '@/DTOS/AdministrationCompany/Search';

const AdministrationCompanyService = {
  search: (search: Search) => {
    return request('/administrationCompany/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      type: any;
      name: any;
      country: any;
      locality: any;
      address: any;
      phone: any;
      email: any;
      bankAccount: any;
      bank: any;
      cnp: any;
      signature: any;
      cui: any;
      registrationNumber: any;
      activityDescription: any;
      leadership: any;
      webAddress: any;
    }
  ) => {
    const handleFieldValue = (fieldValue: any) => {
      if (Array.isArray(fieldValue)) {
        return fieldValue;
      } else {
        return [fieldValue];
      }
    };
    return request('/administrationCompany/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          type: formData.type,
          name: formData.name,
          country: formData.country,
          locality: formData.locality,
          address: formData.address,
          phone: handleFieldValue(formData.phone),
          email: handleFieldValue(formData.email),
          bankAccount: formData.bankAccount,
          bank: formData.bank,
          cnp: formData.cnp,
          signature: formData.signature,
          cui: formData.cui,
          registrationNumber: formData.registrationNumber,
          activityDescription: formData.activityDescription,
          leadership: formData.leadership,
          webAddress: formData.webAddress,
        },
      }),
    });
  },
};

export default AdministrationCompanyService;
